import * as React from "react";
import Breadcrumbs from "./../common/components/FDIC/Breadcrumbs";
import BankList from "./components/bankList";
import BankDetails from "./components/bankDetails";
import "../common/styles/externalApp.css";

interface AppState {}

class App extends React.Component<any, AppState> {

  componentDidMount() {}

  isBankSelected = () => {
    let isSelected = false;
    if (this.props.match.params.id) {
      isSelected = true;
    }
    return isSelected;
  };

  public render() {
    let content = <BankList />;
    if (this.isBankSelected()) {
      content = <BankDetails bankid={this.props.match.params.id} />;
    }
    return (
      <div className="drripApp">
        <Breadcrumbs isBankView={this.isBankSelected()} />
        <main id="content" className="">
          {content}
        </main>
      </div>
    );
  }
}

export default App;
